import {identity, isFunction, uniqueId} from 'lodash';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useDataLoader} from './useDataLoader';

const Loader = props => {
    const {id, children = null, promises = [], skipSpinner, validate, ignoreErrors = false, onSuccess, onError} = props,
        {ready, error, active, showSpinner} = useDataLoader({id, promises, skipSpinner, validate, ignoreErrors, onSuccess, onError});

    if (showSpinner && !active) return null;
    return React.Children.map(children, c => {
        if (ready || error || !showSpinner || ['WaitWhileBusy', 'Loader', 'Switch'].includes(c?.type?.name) || !c?.type?.name) {
            return c;
        }
        return null;
    });
};

export default Loader;
